module.exports = __webpack_public_path__ + "static/media/ehms-pic3.c30639af.gif";